module.exports = __webpack_public_path__ + "static/media/Slanted Walls in Revit.cfd2d454.png";